import { render, staticRenderFns } from "./feescategories.vue?vue&type=template&id=557ca6dc&"
import script from "./feescategories.vue?vue&type=script&lang=js&"
export * from "./feescategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports